import * as ActionTypes from '../actionTypes';
import { userPool } from './awsProfile';

const dispatchSignOut = () => ({
  type: ActionTypes.USER_SIGN_OUT
});

const dispatchClearAllData = () => ({
  type: ActionTypes.CLEAR_ALL_DATA
});

const dispatchUnAuthUser = () => ({
  type: ActionTypes.UN_AUTH_USER
});

export const userSignOut = () => (dispatch) => {
  dispatch(dispatchSignOut());
  signOutUser(dispatch)
    .then((res) => {
      dispatch(dispatchClearAllData());
    })
    .catch((err) => { window.location.reload() });
};
function signOutUser(dispatch) {
  const p = new Promise((res, rej) => {
    const cognitoUser = userPool.getCurrentUser();
    localStorage.clear();
    dispatch(dispatchUnAuthUser());
    cognitoUser.signOut();
    window.location.reload();
  });
  return p;
}
